<template>404</template>

<style scoped lang="scss"></style>
